import { render, staticRenderFns } from "./Descprition2.vue?vue&type=template&id=708673f2&"
import script from "./Descprition2.vue?vue&type=script&lang=js&"
export * from "./Descprition2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports